// FailurePage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FailurePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('membershipData');
  }
  , []);

  const goToHome = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-100">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Payment Cancelled!</h1>
        <p className="text-gray-700 mb-6">
          Oops! Something went wrong. Please try again later.
        </p>
        <button
          onClick={goToHome}
          className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-full transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default FailurePage;
